import assets from '../../public/branding/generated/assets.json'

const baseUrl = process.env.BASE_URL || '/'
const assetUrl = filename => `${baseUrl}branding/generated/${filename}`

export const brandLogo = {
  main: assetUrl(assets.main),
  icon: assetUrl(assets.icon),
  svg: assetUrl(assets.main),
  alt: 'Logo',
}

export default brandLogo
